export const SEED_FORMULATION_MESSAGES = {
  nameEmpty: 'Seed Name cannot be empty.',
  dateEmpty: 'Date cannot be empty.',
  concInvalid: 'Concentration must be a valid number.',
  concUnitNumeric: 'Concentration unit cannot be a numeric value.',
  concUnitEmpty: 'Concentration unit cannot be empty.',
} as const;
